<template>
  <div class="logout">
    <div class="text">
        <p v-html="$t('lang.logout.atten')"></p>
    </div>
    <input
      v-model="keyWords"
      type="textarea"
      class="username-input"
      :placeholder="this.$t('lang.logout.placeholder')"
      @input="userNameFocus()"
    />
    <div class="logout-btn-wrapper">
       <button
        type="submit"
        class="logout-btn"
        :class="submitActive ? 'active' : ''"
        @click="submit()"
      >{{$t('lang.logout.confirm')}}</button>
    </div>
          <!-- :disabled="isOperating ? true: false" -->

  </div>
</template>

<script>
import { Toast, Button, Field } from "vant";
import {closeAccount, accountTest} from "@/api/api";
export default {
  data() {
    return {
      keyWords: "",
      border: false,
      submitActive: false,
    };
  },
  components: {
    [Toast.name]: Toast,
    [Button.name]: Button,
    [Field.name]: Field,
  },
  beforeMount: function() {
    this.init();
  },
  methods: {
    init() {
    },
    userNameFocus() {
      this.submitActive = true;
    },
    submit() {
      var that = this;
      if(that.keyWords != that.$t('lang.logout.keyWords')){
        Toast(that.$t('lang.logout.keyWordsAtten'));
      }else{
        closeAccount().then(res => {
          console.log(res)
          if(res.data.error){
              Toast(res.data.error.message);
          }else{
              Toast.success(that.$t('lang.logout.logoutSuccess'));
              this.setupWebViewJavascriptBridge(function(bridge) {
                  bridge.callHandler("closeaccount", {}, function(response) {});
              });
          }
        })
      }
    },
    setupWebViewJavascriptBridge: function(callback) {
      var that = this;
      if (window.WebViewJavascriptBridge) {
        return callback(WebViewJavascriptBridge);
      } else if (window.WVJBCallbacks) {
        return window.WVJBCallbacks.push(callback);
      } else {
        document.addEventListener(
          "WebViewJavascriptBridgeReady",
          function() {
            callback(WebViewJavascriptBridge);
          },
          false
        );
      }
      window.WVJBCallbacks = [callback];
      var WVJBIframe = document.createElement("iframe");
      WVJBIframe.style.display = "none";
      var WVJBIframeSrc = that.isiOS
        ? "https://__bridge_loaded__"
        : "wvjbscheme://__BRIDGE_LOADED__";

      WVJBIframe.src = WVJBIframeSrc;
      document.documentElement.appendChild(WVJBIframe);
      setTimeout(function() {
        document.documentElement.removeChild(WVJBIframe);
      }, 0);
    },
  }
};
</script>
<style lang="less" scoped>
input::-webkit-input-placeholder {
  font-size: 14px;
  color: #999999;
}
.logout {
  .text {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFangSC;
    font-weight: 500;
    color: rgba(34, 34, 34, 1);
    line-height: 28px;
    margin: 0 32px;
    padding-top: 50px;
    text-align: center;
  }
  .username-input {
    width: 288px;
    height: 52px;
    margin: 0 auto;
    background:rgba(241,241,243,1);
    border-radius:59px;
    margin: 30px 30px 0 30px;
    border: none;
    padding-left: 23px;
    font-size: 14px;
  }
  .logout-btn-wrapper{
    text-align: center; 
    .logout-btn {
      width: 311px;
      height: 52px;
      border-radius: 26px;
      border: 1px solid rgba(204, 204, 204, 1);
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFangSC;
      font-weight: 500;
      color: rgba(204, 204, 204, 1);
      line-height: 26px;
      margin-top: 40px;
      background: #fff;
    }
    .logout-btn.active {
      border: 1px solid #FFAEAA;
      color: #FF3A30;
    }
  }
  
}
</style>    
